import ComponentBasePrototype from 'ComponentBasePrototype';
import $ from 'jquery';

export default class Iframe extends ComponentBasePrototype {
  build() {
    const aspectRatioSelection = this.data.aspectRatio;
    const aspectRatioMaintained = aspectRatioSelection === 'fourThree' || aspectRatioSelection === 'sixteenNine';

    if (aspectRatioMaintained) {
      const iFrame = this.node.find('.iframe');
      const aspectRatio = aspectRatioSelection === 'fourThree' ? 3 / 4 : 9 / 16;

      this.maintainAspectRatio(iFrame, aspectRatio);

      $(window).on('resize', () => {
        this.maintainAspectRatio(iFrame, aspectRatio);
      });

      // This gets rid of some excess white space underneath the iframe component
      this.node.css('line-height', '0px');
    }

    this.showContent();
  }

  maintainAspectRatio(iFrame, aspectRatio) {
    const width = iFrame.width();
    const newHeight = width * aspectRatio;
    iFrame.height(newHeight);
  }

  showContent() {
    if (this.hasFlash() || 'requireFlash' in this.data === false || this.data.requireFlash === false) {
      this.node.find('.flash-enabled').show();
    } else {
      this.node.find('.no-flash').show();
    }
  }

  hasFlash() {
    try {
      if (new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash')) {
        return true;
      }
    } catch (e) {
      if (navigator.mimeTypes && navigator.mimeTypes['application/x-shockwave-flash'] !== undefined && navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
        return true;
      }
    }

    return false;
  }
}
